import { render } from "./polizzaData.vue?vue&type=template&id=40030a96&ts=true"
import script from "./polizzaData.vue?vue&type=script&lang=ts"
export * from "./polizzaData.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__